module.exports = __webpack_public_path__ + "static/media/bokeh1080.d317fb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/bokeh1080.jpg
// module id = 1355
// module chunks = 0